export function detectBrowser(agent?: string) {
  const userAgent = agent || navigator?.userAgent;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = 'chrome';
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = 'firefox';
  } else if (userAgent.match(/safari/i)) {
    browserName = 'safari';
  } else if (userAgent.match(/opr\//i)) {
    browserName = 'opera';
  } else if (userAgent.match(/edg/i)) {
    browserName = 'edge';
  } else if (userAgent.match(/msie/i) || userAgent.match(/trident/i)) {
    browserName = 'ie';
  } else {
    browserName = 'other';
  }

  return browserName;
}

export default function detectPlatform(agent?: string) {
  const userAgent = agent || navigator?.userAgent;
  if (/android/i.test(userAgent)) {
    return 'android';
  } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
    return 'ios';
  } else {
    return 'web';
  }
}
